import React from "react";
import { Box, Divider } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";
import { Skeleton } from "@material-ui/lab";

//styles
import useStyles from "./styles";

const UnitsModelsCradSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <CustomCard
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.warpperUnitsModelsCrad}
    >
      <Box className={styles.headerCard}>
        <Skeleton variant="text" width={30} height={30} />
        <Divider className={styles.divider} />
      </Box>
      <Box className={styles.bodyCard}>
        <Skeleton variant="text" width={30} height={25} />
        <Box className={styles.detailsUnits}>
          <Box className={styles.containerUnitItem}>
            <Skeleton variant="text" width={20} height={25} />
            <Skeleton variant="text" width={50} height={25} />
          </Box>
          <Box className={styles.containerUnitItem}>
            <Skeleton variant="text" width={20} height={25} />
            <Skeleton variant="text" width={50} height={25} />
          </Box>
          <Box className={styles.containerUnitItem || ""}>
            <Skeleton variant="text" width={20} height={25} />
            <Skeleton variant="text" width={50} height={25} />
          </Box>
        </Box>
        <Box className={styles.dataContainer}>
          <Skeleton variant="text" width={25} height={30} />
          <Skeleton variant="text" width={50} height={30} />
        </Box>
        <Box className={styles.dataContainer}>
          <Skeleton variant="text" width={25} height={30} />
          <Skeleton variant="text" width={50} height={30} />
        </Box>
      </Box>
    </CustomCard>
  );
};
export default UnitsModelsCradSkeleton;
